module.exports = __webpack_public_path__ + "img/desc-title.90cfd56b.png";